import { PureFunctional, React } from '../../react';

import cx from './style.less';
export default PureFunctional<{ visible: boolean }>(`Fullscreen`)(
    ({ visible, children }) => (
        // visible?
        <div className={cx(visible? 'wcag-visible': 'wcag-invisible')}> 
            <div className={cx('backdrop', visible? 'backdrop-opacity-visible': 'backdrop-opacity-invisible')}
            />
            <div className={cx('component', 'motioncomponent', visible ? 'transform0': 'transform1')} 
            >{children}</div>
        </div>
        // :null
));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/shared/fullscreen/index.tsx